export default function IconDownChevron({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <path d="M17.7071 9.29289C17.3166 8.90237 16.6836 8.90237 16.293 9.29289L12.0001 13.5859L7.70711 9.29289L7.63093 9.22453C7.23816 8.90418 6.65916 8.92678 6.29304 9.29289C5.92693 9.65901 5.90434 10.238 6.22468 10.6308L6.29304 10.707L11.293 15.707C11.6836 16.0975 12.3166 16.0975 12.7071 15.707L17.7071 10.707C18.0976 10.3164 18.0976 9.68342 17.7071 9.29289Z" />
        </svg>
    );
}
